<template>
    <div class="country"><img class="flag" :src="country.flag"></img>{{country.name}}</div>
    <!-- <div class="country">{{country.name}}</div> -->
</template>


<script>

export default {
  components: { },
  props: { country: Object },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
  },
  created() {
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .country {
        @include font-size(16px);
        width: fit-content;
        line-height: 20px;
        font-weight: bold;
        font-size: 14px;

        .flag {
            margin-right: 10px;
            height: 15px;
            width: auto;
        }
    }
</style>